import React from 'react';
import { CheckIcon, DrillIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach Drilling & Well Engineering with confidence starting today'];
export function FinalCta() {
  return <section className="bg-green-950 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-86" data-mp="1jbahue7foi1w">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-87" data-mp="1edipjj2vmtx6">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-amber-400" data-id="element-88" data-mp="1t3g6bdyh8hcc">
          <DrillIcon className="h-4 w-4" aria-hidden="true" data-id="element-89" data-mp="1o3lixkdwu9w1" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-stone-50 sm:text-4xl" data-id="element-90" data-mp="222uwecaqepwb">
          Created by drilling and well engineering education specialists, for educators worldwide
        </h2>

        <Countdown className="mt-8" data-id="element-91" data-mp="n7ff9o5bd0d1" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl bg-stone-50 p-6 text-left shadow-2xl shadow-black/30 sm:flex-row sm:items-center sm:justify-between" data-id="element-92" data-mp="s4fk5vqffx2k">
          <p data-id="element-93" data-mp="x2h40ivog0f3">
            <b className="block text-sm uppercase leading-tight text-green-950" data-id="element-94" data-mp="x64z3mgrsuvx">{productShortName}</b>
            <span className="text-sm text-stone-600" data-id="element-95" data-mp="120inh4x0m1r3">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="shrink-0 sm:text-right" data-id="element-96" data-mp="1b1ywp9c3fxtq">
            <p className="text-sm text-stone-600" data-id="element-97" data-mp="1fujpq8n6e6w7">
              <span className="mr-2 line-through" data-id="element-98" data-mp="1fus1fx7kb65t">{priceBefore}</span>
              <b className="text-base text-green-900" data-id="element-99" data-mp="1ktmlf2h9n0ri">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-100" data-mp="1psple8ie2gsm">
              Get my teacher ready now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-green-100" data-id="element-101" data-mp="3qufdfoonxirm">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-102" data-mp="3lxf9pkfacs3o">
              <CheckIcon className="h-4 w-4 text-amber-400" aria-hidden="true" data-id="element-103" data-mp="3imry82iqn9n" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}